<ng-template #statusCellTemplate let-row>
  @if (isActiveTariff(row)) {
    <span class="c-tag context:success">{{ 'portTariffs.status.active' | translate }}</span>
  } @else {
    <span class="c-tag context:error">
      {{ 'portTariffs.status.archived' | translate }}
      @if (row.archiveReason) {
        <span class="c-tooltip c-tooltip--top">{{ row.archiveReason }}</span>
      }
    </span>
  }
</ng-template>

@if (selectedPortId()) {
  <core-generic-table
    [dataInput]="sortedTariffs()"
    [columns]="tariffColumns()"
    [actions]="tariffActions()"
    [customActions]="tariffCustomActions()"
    [globalActions]="tariffGlobalActions()"
    [showFilter]="false"
    [showSelection]="false"
    [showActions]="true"
    [showCreateButton]="false"
    [enablePagination]="false"
    [rowStyleConfigs]="tariffRowStyleConfigs()"
    [listTitle]="'portTariffs.header.fallbackTitle' | translate"
    class="o-layout__section c-table--scroll">
  </core-generic-table>
} @else {
  <div class="c-empty-state u-card">
    <p>{{ 'portTariffs.emptyState' | translate }}</p>
  </div>
}

<core-generic-modal
  [isOpen]="tariffFormOpen()"
  [title]="tariffFormMode() === 'create' ? ('portTariffs.modals.createTitle' | translate) : ('portTariffs.modals.editTitle' | translate)"
  [mode]="tariffModalMode()"
  [data]="tariffDraft"
  [fields]="tariffModalFields()"
  (save)="onTariffModalSave($event)"
  (close)="closeTariffForm()"
></core-generic-modal>

<core-generic-modal
  [isOpen]="archiveTariffOpen()"
  [title]="'portTariffs.modals.archiveTitle' | translate"
  [mode]="archiveTariffModalMode()"
  [data]="archiveTariffDraft"
  [fields]="archiveTariffModalFields()"
  (save)="onArchiveTariffModalSave($event)"
  (close)="closeArchiveTariff()"
></core-generic-modal>

<core-generic-modal
  [isOpen]="duplicateTariffOpen()"
  [title]="'portTariffs.modals.duplicateTitle' | translate"
  [mode]="duplicateTariffModalMode()"
  [data]="duplicateTariffDraft"
  [fields]="duplicateTariffModalFields()"
  (save)="onDuplicateTariffModalSave($event)"
  (close)="closeDuplicateTariff()"
></core-generic-modal>
